import React from "react";
import { updateTask, deleteTask } from "../services/api";

export default function TaskList({ tasks, onTaskUpdated }) {
  const token = localStorage.getItem("token");

  const handleToggle = async (task) => {
    try {
      const res = await updateTask(task.id, { is_completed: !task.is_completed }, token);
      
      // If task is being marked as complete, get AI congratulation
      if (!task.is_completed) {
        try {
          const congratsRes = await fetch("/api/ai/congratulate", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ task_title: task.title })
          });
          const congratsData = await congratsRes.json();
          alert(congratsData.message || "🎉 Great job!");
        } catch {
          alert("✅ Task completed! Keep up the great work!");
        }
      } else if (res.data.ai_response) {
        alert(res.data.ai_response);
      }
      
      onTaskUpdated();
    } catch (err) {
      console.error(err);
      alert("Failed to update task");
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteTask(id, token);
      onTaskUpdated();
    } catch (err) {
      console.error(err);
      alert("Failed to delete task");
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">
        Your Tasks
      </h2>
      {tasks.length === 0 ? (
        <p className="text-gray-500">No tasks yet. Add one above!</p>
      ) : (
        <ul className="space-y-2">
          {tasks.map((task) => (
            <li
              key={task.id}
              className={`flex justify-between items-center p-3 rounded-lg border ${
                task.is_completed ? "bg-green-100 line-through text-gray-500" : "bg-gray-50"
              }`}
            >
              <div>
                <h3 className="font-semibold">{task.title}</h3>
                <p className="text-sm">{task.description}</p>
                {task.due_date && (
                  <p className="text-xs text-gray-400">
                    Due: {new Date(task.due_date).toLocaleString()}
                  </p>
                )}
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handleToggle(task)}
                  className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                >
                  {task.is_completed ? "Undo" : "Complete"}
                </button>
                <button
                  onClick={() => handleDelete(task.id)}
                  className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
